import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

import { TellentTwoFactorAuthenticationHttpClient } from './tellent-two-factor-authentication-http-client.service';
import { TellentTwoFactorAuthenticationActions } from './tellent-two-factor-authentication.store';

@Injectable({ providedIn: 'root' })
export class TellentTwoFactorAuthenticationEffects {
  private readonly actions$ = inject(Actions);
  private readonly twoFactorAuthenticationHttpClient = inject(
    TellentTwoFactorAuthenticationHttpClient,
  );

  public loadSecuritySetup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentTwoFactorAuthenticationActions.fetch),
      mergeMap(() =>
        this.twoFactorAuthenticationHttpClient.loadSecuritySetup().pipe(
          map(
            data =>
              TellentTwoFactorAuthenticationActions.fetchSuccess({
                payload: data,
              }),
            catchError(error =>
              of(TellentTwoFactorAuthenticationActions.fetchFailed({ payload: error })),
            ),
          ),
        ),
      ),
    ),
  );

  public sendSmsCode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentTwoFactorAuthenticationActions.sendSmsCode),
      switchMap(({ payload }) =>
        this.twoFactorAuthenticationHttpClient.sendSmsCode(payload).pipe(
          map(() => TellentTwoFactorAuthenticationActions.sendSmsCodeSuccess()),
          catchError(error =>
            of(TellentTwoFactorAuthenticationActions.sendSmsCodeFail({ payload: error })),
          ),
        ),
      ),
    ),
  );

  public enableSmsAuth$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentTwoFactorAuthenticationActions.enableSmsAuth),
      switchMap(({ payload }) =>
        this.twoFactorAuthenticationHttpClient
          .enableSmsAuth(payload.phoneNumber, payload.code)
          .pipe(
            map(() => TellentTwoFactorAuthenticationActions.enableSmsAuthSuccess()),
            catchError(error =>
              of(TellentTwoFactorAuthenticationActions.enableSmsAuthFail({ payload: error })),
            ),
          ),
      ),
    ),
  );

  public disableSmsAuth$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentTwoFactorAuthenticationActions.disableSmsAuth),
      switchMap(({ payload }) =>
        this.twoFactorAuthenticationHttpClient.disableSmsAuth(payload).pipe(
          map(() => TellentTwoFactorAuthenticationActions.disableSmsAuthSuccess()),
          catchError(error =>
            of(TellentTwoFactorAuthenticationActions.disableSmsAuthFail({ payload: error })),
          ),
        ),
      ),
    ),
  );

  public enableAppAuth$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentTwoFactorAuthenticationActions.enableAppAuth),
      switchMap(({ payload }) =>
        this.twoFactorAuthenticationHttpClient.enableAppAuth(payload).pipe(
          map(() => TellentTwoFactorAuthenticationActions.enableAppAuthSuccess()),
          catchError(error =>
            of(TellentTwoFactorAuthenticationActions.enableAppAuthFail({ payload: error })),
          ),
        ),
      ),
    ),
  );

  public disableAppAuth$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentTwoFactorAuthenticationActions.disableAppAuth),
      switchMap(({ payload }) =>
        this.twoFactorAuthenticationHttpClient.disableAppAuth(payload).pipe(
          map(() => TellentTwoFactorAuthenticationActions.disableAppAuthSuccess()),
          catchError(error =>
            of(TellentTwoFactorAuthenticationActions.disableAppAuthFail({ payload: error })),
          ),
        ),
      ),
    ),
  );

  // waiting for account recovery
  // public dismissRecoveryInfobox$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(TellentTwoFactorAuthenticationActions.dismissRecoveryInfobox),
  //     switchMap(() =>
  //       this.twoFactorAuthenticationHttpClient.dismissRecoveryInfobox().pipe(
  //         map(() => TellentTwoFactorAuthenticationActions.dismissRecoveryInfoboxSuccess()),
  //         catchError(error =>
  //           of(
  //             TellentTwoFactorAuthenticationActions.dismissRecoveryInfoboxFail({ payload: error }),
  //           ),
  //         ),
  //       ),
  //     ),
  //   ),
  // );

  public refetchSecuritySetup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        TellentTwoFactorAuthenticationActions.enableSmsAuthSuccess,
        TellentTwoFactorAuthenticationActions.disableSmsAuthSuccess,
        TellentTwoFactorAuthenticationActions.disableAppAuthSuccess,
        TellentTwoFactorAuthenticationActions.enableAppAuthSuccess,
        // TellentTwoFactorAuthenticationActions.dismissRecoveryInfoboxSuccess,   // waiting for account recovery
      ),
      map(() => TellentTwoFactorAuthenticationActions.fetch()),
    ),
  );
}
